export default __webpack_public_path__ + "static/media/mobile13.2ff3b206.jfif";